export function IconPowerOff() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM4 12C4 9.79058 4.89434 7.79196 6.34315 6.34315L4.92893 4.92893C3.12038 6.73748 2 9.23885 2 12H4ZM6.34315 6.34315C7.79196 4.89434 9.79058 4 12 4V2C9.23885 2 6.73748 3.12038 4.92893 4.92893L6.34315 6.34315ZM4.92893 6.34315L17.6569 19.0711L19.0711 17.6569L6.34315 4.92893L4.92893 6.34315ZM20 12C20 14.2094 19.1057 16.208 17.6569 17.6569L19.0711 19.0711C20.8796 17.2625 22 14.7611 22 12H20ZM17.6569 17.6569C16.208 19.1057 14.2094 20 12 20V22C14.7611 22 17.2625 20.8796 19.0711 19.0711L17.6569 17.6569Z"
        fill="currentColor"
      />
    </svg>
  );
}
